module.exports = __webpack_public_path__ + "static/img/12.b55e2dda.png";